import TripItemBus from './trip-item-bus-component';
import TripItemBusService from './trip-item-bus-service';

import './trip-item-bus.scss';

const MODULE_NAME = 'app.trip.item-bus';
const module = angular.module(MODULE_NAME, [])
    .directive(TripItemBus.DIRECTIVE_NAME, TripItemBus)
    .service(TripItemBusService.SERVICE_NAME, TripItemBusService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-item-bus/trip-item-bus-module.js